import { Helmet } from "react-helmet";

export const SeoHead = () => (
    <Helmet>
        <title>Fun Games - Play Online | Sushila Public School</title>

        {/* Meta Description */}
        <meta
            name="description"
            content="Play fun and educational games like Tic Tac Toe, Snake, and more! Specially made for students of Sushila Public School."
        />

        {/* Robots Tag for Indexing */}
        <meta name="robots" content="index, follow" />

        {/* Canonical URL */}
        <link rel="canonical" href="https://game.sushilapublicschool.com" />

        {/* Open Graph Tags (for sharing on social media) */}
        <meta property="og:title" content="Fun Games - Play Online" />
        <meta property="og:description" content="Enjoy games made for students at Sushila Public School." />
        <meta property="og:url" content="https://game.sushilapublicschool.com" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://game.sushilapublicschool.com/og-image.jpg" /> {/* Optional preview image */}

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Fun Games - Play Online" />
        <meta name="twitter:description" content="Fun games made for Sushila Public School students." />
        <meta name="twitter:image" content="https://game.sushilapublicschool.com/og-image.jpg" />
        <meta name="google-adsense-account" content="ca-pub-6545634854364065" />
        <script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6545634854364065"
            crossorigin="anonymous"></script>
    </Helmet>
);
